import React, {useState, useEffect} from "react";
import {cartTools} from "./useCart";
import UnavailableItem from "../products/Unavailable.Item";

const UnavailableItemsList = () => {
  const [unavailableItems, setUnavailableItems] = useState([]);

  const {getUnavailableItems} = cartTools();

  useEffect(() => {
    setUnavailableItems(getUnavailableItems());
  }, []);

  return <div className="unavailable-items">
    {!!unavailableItems?.length && unavailableItems.map(item => {
      return <UnavailableItem key={item.product_id} product={item.productData}/>;
    })}
  </div>;
};

export default UnavailableItemsList;
